import { PUBLIC_IPS_NO_REVERSE_DNS } from 'app/util/constants';

function fn(value) {
  if (value) {
    return PUBLIC_IPS_NO_REVERSE_DNS.findIndex((ip) => ip === value) < 0;
  }

  return true;
}

export default {
  message:
    "Public DNS IPs do not add any value to Kentik's in-platform reverse DNS mapping and are, on average, less performant. Please remove these IP's (google, cloudflare, openDNS, Quad9, etc)",
  fn
};
